import { render, staticRenderFns } from "./KioskQuestionsForm.vue?vue&type=template&id=236437a6&"
import script from "./KioskQuestionsForm.vue?vue&type=script&lang=js&"
export * from "./KioskQuestionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports